import React, { Component } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../components/BlankState';

class PendingQuoteTable extends Component {

	render(){
		let { policies, quote } = this.props;
		
		const {
			creator_name,
			proposer_name,
			creator_email,
			creator_phone,
			intermediary_name,
			premium,
			total_cfr,
			total_sum_insured,
			created

		} = quote;

		return(
			<div className="clearfix">
				<h5>Quote Details</h5>
				<table className="table table-bordered">
					<tbody>
					   <tr>
							<th style={{ width: "200px" }}>Creator Name</th>
							<td colSpan="2">{ proposer_name || '-' }</td>
						</tr>
						<tr>
							<th>Proposer Name</th>
							<td colSpan="2">
								<span>{ creator_name || '-' }</span><br/>
							</td>
						</tr>
						
						<tr>
							<th>Creator Email</th>
							<td colSpan="2">{ creator_email || '-' }</td>
						</tr>
						<tr>
							<th>Creator Phone</th>
							<td colSpan="2">{ creator_phone || '-' }</td>
						</tr>
						<tr>
							<th>Intermediary</th>
							<td colSpan="2">{ intermediary_name || '-' }</td>
						</tr>
						<tr>
							<th>Premium (TSh.)</th>
							<td colSpan="2">{ numeral(premium).format('0,0.00') }</td>
						</tr>
						<tr>
							<th>Total CFR (TSh.)</th>
							<td colSpan="2">{ numeral(total_cfr).format('0,0.00') }</td>
						</tr>
						<tr>
							<th>Total Sum Insured (TSh.)</th>
							<td colSpan="2">{ numeral(total_sum_insured).format('0,0.00') }</td>
						</tr>
						<tr>
							<th>Created On</th>
							<td colSpan="2">{ moment(created).format('MMM Do, YYYY') }</td>
						</tr>
					</tbody>
				</table>

				<h5>Goods</h5>

				{ policies.quote_goods.length > 0 && !policies.quote_goods_loading ?
					
					<table className="table table-bordered">
					<thead>
						<tr>
							<th>Goods Type</th>
							<th>Premium Rate</th>
							<th width="20%" className="text-right">CFR &amp; F (USD)</th>
							<th width="30%" className="text-right">CFR &amp; F (TZS)</th>
						</tr>
					</thead>
					<tbody>
						{
							policies.quote_goods.map((good, index)=>{
								const { premium_rate, cfr,section_name } = good;
								
								return(
									
									<tr key={ index }>
										<td>{ section_name || '-' }</td>
										<td>{ premium_rate || '0' }</td>
										<td width="20%" className="text-right">
											{ cfr || '' }
										</td>
										<td width="30%" className="text-right">
											{ cfr || '' }
										</td>
									</tr>
								)	
							})
						}
						<tr>
							<th colSpan="3" className="text-right">{ numeral(total_cfr).format('0,0.00') }</th>
							<th className="text-right">{ numeral(total_sum_insured).format('0,0.00') }</th>
						</tr>
					</tbody>
					</table>
				:
					<BlankState 
						data={ policies.quote_goods } 
						dataName="Quote Goods" 
						isDataLoading={ policies.quote_goods_loading } />
                }
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user,
	policies: state.policies
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingQuoteTable);


// WEBPACK FOOTER //
// ./src/components/PendingQuoteTable.js